import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ModalHOC } from 'common';
import { EditIcon, BasketIcon } from 'common/icons';
import { PaginationTable, ActionsButton, MoneyCell, RowLink } from 'common/components';

import { withTheme } from 'common/styling/theme';
import { staticStyles, getDynamicStyles } from './style';

const BonusManagementTable = ({
  data,
  getList,
  handleDelete,
  showModal,
  loading,
  location,
  history,
  params,
  theme,
}) => {
  const editBonusesClick = (e, id) => {
    e.stopPropagation();
    history.push(`/backoffice/bonuses/${id}/edit`);
  };

  const deleteBonusesClick = (e, id) => {
    e.stopPropagation();
    showModal({
      caption: { id: 'confirmDeleteBonus' },
      content: {
        id: 'confirmText',
      },
      actionButton: {
        textId: 'justYes',
        handler: () => handleDelete({ id, queryParams: params }),
        type: 'error',
      },
      cancelButton: {
        textId: 'justNo',
      },
    });
  };

  /* eslint-disable */
  const columns = [
    {
      id: 'logo',
      Header: () => null,
      Cell: ({
        row: {
          original: { logo, id },
        },
      }) => (
        <RowLink link={`/backoffice/bonuses/${id}/edit`} isPreviewCell>
          <img src={logo} alt="logo" className="BonusManagementTable__logo" />
        </RowLink>
      ),
      isPreviewCell: true,
    },
    {
      accessor: 'title',
      Header: 'justTitle',
      Cell: ({
        row: {
          original: { title, id },
        },
      }) => (
        <RowLink link={`/backoffice/bonuses/${id}/edit`} isPreviewCell>
          <span className="title">{title}</span>
        </RowLink>
      ),
      isPreviewCell: true,
    },
    {
      accessor: 'type',
      Header: 'justType',
      Cell: ({
        row: {
          original: { type, defaultBonusType, id },
        },
      }) => (
        <RowLink link={`/backoffice/bonuses/${id}/edit`}>
          <div className="BonusManagementTable__types">
            <span className="type">{type}</span>
            <FormattedMessage id={defaultBonusType === 'balance' ? 'justBalance' : 'justCredit'}>
              {txt => <span className="defaultType">{txt}</span>}
            </FormattedMessage>
          </div>
        </RowLink>
      ),
      isPreviewDescriptionCell: true,
    },
    {
      accessor: 'value',
      Header: 'justValue',
      Cell: ({
        row: {
          original: { value, id },
        },
      }) =>
        typeof value === 'object' ? (
          <RowLink link={`/backoffice/bonuses/${id}/edit`} isPreviewCell>
            <MoneyCell inTable value={value} loading={loading} />
          </RowLink>
        ) : (
          <RowLink link={`/backoffice/bonuses/${id}/edit`} isPreviewCell>
            <span>{`${value}${typeof value === 'number' ? '%' : ''}`}</span>
          </RowLink>
        ),
      isPreviewCell: true,
    },
    {
      Header: 'justActions',
      Cell: ({
        row: {
          original: { id },
        },
      }) => (
        <div className="actions">
          <ActionsButton
            tooltipId={`Edit__tooltip-${id}`}
            tooltipTextId="justEdit"
            edit
            onClickFunc={e => editBonusesClick(e, id)}>
            <EditIcon />
          </ActionsButton>
          <ActionsButton
            tooltipId={`Delete__tooltip-${id}`}
            tooltipTextId="justDelete"
            deleteType
            onClickFunc={e => deleteBonusesClick(e, id)}>
            <BasketIcon />
          </ActionsButton>
        </div>
      ),
    },
  ];
  /* eslint-enable */

  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  return (
    <div className="BonusManagementTable">
      <PaginationTable
        data={data}
        columns={columns}
        onRowClick={(_, rowInfo) => history.push(`/backoffice/bonuses/${rowInfo.original.id}/edit`)}
        getList={getList}
        loading={loading}
        location={location}
        history={history}
        params={params}
      />
      <style jsx global>
        {staticStyles}
      </style>
      <style jsx global>
        {dynamicStyles}
      </style>
    </div>
  );
};

BonusManagementTable.propTypes = {
  data: PropTypes.object.isRequired,
  getList: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  theme: PropTypes.object,
};

BonusManagementTable.defaultProps = {
  loading: false,
  theme: {},
};

export default withTheme()(ModalHOC(BonusManagementTable));
export { BonusManagementTable };
